import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button, Header, Icon, Segment} from 'semantic-ui-react';
import {routeNodeSelector, actions as routerActions} from 'redux-router5';
import {isPaymentsApp} from 'helpers';

const PayPalCallback = props => {
  const goBack = () => {
    if (props.router.route.params && props.router.route.params.returnUrl) {
      window.location = props.router.route.params.returnUrl;
    } else {
      props.navigateTo('home');
    }
  };

  return (
    <Segment textAlign="center">
      <Icon color="green" name="check circle outline" size="huge" />

      <Header as="h1" style={{marginBottom: 25}}>
        Your PayPal payment was successfully submitted!
      </Header>
      {!isPaymentsApp() && (
        <Button onClick={goBack} primary type="button">
          Back
        </Button>
      )}
    </Segment>
  );
};

PayPalCallback.propTypes = {
  router: PropTypes.object.isRequired,

  // functions
  navigateTo: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  ...routeNodeSelector('payment')(state),
  router: state.router,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      navigateTo: routerActions.navigateTo,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PayPalCallback);



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PayPalCallback/index.js